import { createLayout, type Layout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { lazyForPaint, lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import type ResourcesCleanup from './ui/resources-invalidate/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanResourcesInvalidate = lazyForPaint<typeof ResourcesCleanup>(
	() =>
		import(/* webpackChunkName: "async-plan-resources-invalidate" */ './ui/resources-invalidate'),
	{ ssr: false },
);

export const Onboarding = componentWithFG(
	'quickstart_onboarding_in_jira_plans',
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyAfterPaint(() => import(/* webpackChunkName: "async-plan-onboarding" */ './ui/onboarding'), {
		ssr: false,
	}),
	() => null,
);
Onboarding.displayName = 'Onboarding';

export const RightSidebars = componentWithFG(
	'quickstart_onboarding_in_jira_plans',
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyAfterPaint(
		() => import(/* webpackChunkName: "async-plan-right-sidebars" */ './ui/right-sidebars'),
		{ ssr: false },
	),
	() => null,
);
RightSidebars.displayName = 'RightSidebars';

export const planLayout: Layout = createLayout({
	rightSidebars: [RightSidebars],
	globalComponents: [LazyPlanResourcesInvalidate, Onboarding],
});
